var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTriangleLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 170,
    viewBox: "0 0 186 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.4582 42.3086C65.0997 18.6808 71.9205 6.86694 80.8253 2.90223C88.5925 -0.555948 97.4623 -0.555948 105.23 2.90223C114.134 6.86694 120.955 18.6808 134.597 42.3086L166.38 97.3587C180.021 120.986 186.842 132.8 185.823 142.494C184.934 150.95 180.5 158.632 173.621 163.629C165.735 169.359 152.094 169.359 124.811 169.359H61.2442C33.9612 169.359 20.3198 169.359 12.4338 163.629C5.55532 158.632 1.12042 150.95 0.231693 142.494C-0.787208 132.8 6.03354 120.986 19.675 97.3586L51.4582 42.3086Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleLight);
export default __webpack_public_path__ + "static/media/triangleLight.55bc9b5e.svg";
export { ForwardRef as ReactComponent };